import React from "react";
import { DA_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import { V1 } from "./v1/ProductDetailsV1.component";

const featureName = "blockPDPSiloHouses";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const DA_ProductDetailsSiloAndHouse = React.forwardRef(
    // eslint-disable-next-line unused-imports/no-unused-vars
    ({ version, ...props }: any, ref: any) => (
        <DA_FeatureHandler
            featureName={featureName}
            featureVersions={versions}
            version={version}
            {...props}
        />
    )
);

DA_ProductDetailsSiloAndHouse.displayName = "DA_ProductDetailsSiloAndHouse";
